import React from 'react'
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import heart from "../assests/heart.png";
import Col from "react-bootstrap/Col";
import Image1 from "../assests/linkedin.png";
import Image2 from "../assests/github.png";
import Image3 from "../assests/phone.png";
import Image4 from "../assests/email.png";
import Image5 from "../assests/whatsapp.png";
import { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
function Introduction() {
  const phoneNumber = '7036567374';

  const whatsAppUrl = `https://wa.me/${phoneNumber}`;
  const emailAddress = 'N190487@rguktn.ac.in';

  const mailtoUrl = `mailto:${emailAddress}`;
 
  const telUrl = `tel:${phoneNumber}`;
  useEffect(() => {
    AOS.init({
      duration: 900, 
      easing: 'ease-in-out',
    });
  }, []);
  return (
      <Container className="mb-5" >
        <Row>
        <p className="color font1" data-aos="fade-right" >Hi, &nbsp; my name is</p>
        <p className='work text-white' data-aos="fade-right" > Shaik Gouse</p>
        <p className='work text-white' data-aos="fade-right" > I <img src={heart} width={75} style={{paddingBottom:"17px"}} alt="heart-icon"></img> Software  Development.</p>
            <Col lg={8} md={8} sm={10} xs={12} data-aos="fade-right" >
            <p  className=' font2 color2' >Dedicated and results-driven Full Stack Developer with a specialization in React.js frontend development. Proven track record of delivering high-quality, scalable solutions within project deadlines. Adept at collaborating with cross-functional teams to translate client requirements into responsive and intuitive user interfaces.</p>
            </Col>
        </Row><div data-aos="fade-right"  className='gap'>
       <a href="https://www.linkedin.com/in/shaik-gouse-bb34a3254"> <img src={Image1}  className='gap but1' alt="linkedin-icon"></img> </a>  <a href="https://github.com/ShaikMohammedGouse/"><img src={Image2}  className='gap but1' alt="linkedin-icon"></img></a>  <a href={telUrl}><img src={Image3} className='gap but1' alt="linkedin-icon"></img></a> <a href={mailtoUrl}> <img className='gap but1' src={Image4} alt="linkedin-icon"></img> </a> <a href={whatsAppUrl}> <img className='gap but1' src={Image5} alt="linkedin-icon"></img>  </a>
      </div>
      </Container>
  )
}

export default Introduction
